import {MrSneeki} from './MrSneeki/MrSneeki.js';
import css from './index.css';
import {MeownessRays} from "./MeownessRays/MeownessRays";
import {Warning} from "./Warning/Warning";
import {MeowCount} from "./MeowCount/MeowCount";
import {CatBox} from "./CatBox/CatBox";

const mrSneekies = [new MrSneeki(true)];
const meownessRays = new MeownessRays();
const meowCount = new MeowCount();
meowCount.set(mrSneekies.length);

const box = new CatBox();
const warning = new Warning();

const BASE_TRESHOLD = 10;
const TRESHOLD = {
    WARNING: BASE_TRESHOLD,
    DANGER: Math.round(BASE_TRESHOLD * 2),
    MRAYS_SLOW: Math.round(BASE_TRESHOLD * 2.3),
    MRAYS_MEDIUM: Math.round(BASE_TRESHOLD * 2.8),
    MRAYS_FAST: Math.round(BASE_TRESHOLD * 3.4),
    GLITCH: Math.round(BASE_TRESHOLD * 4),
    EXPLOSION: Math.round(BASE_TRESHOLD * 5)
}

box.onAfterCatDrop(() => {
    mrSneekies.push(new MrSneeki(true));
    meowCount.set(mrSneekies.length);

    switch (mrSneekies.length) {
        case TRESHOLD.WARNING:
            meowCount.enableWarning();
            break;
        case TRESHOLD.DANGER:
            meowCount.enableStrongWarning();
            warning.activate();
            break;
        case TRESHOLD.MRAYS_SLOW:
            meownessRays.activate();
            break;
        case TRESHOLD.MRAYS_MEDIUM:
            meownessRays.engageMediumPower();
            warning.setMediumSeverity();
            break;
        case TRESHOLD.MRAYS_FAST:
            meownessRays.engageHeavyPower();
            break;
        case TRESHOLD.GLITCH:
            document.body.className = css.glitch;
            warning.setMaxSeverity();
            break;
        case TRESHOLD.EXPLOSION:
            // TODO resetto
            box.disable();
            mrSneekies.forEach(cat => cat.vanish());

            setTimeout(() => {
                // some cats are stubborn... >:|
                mrSneekies.forEach(cat => cat.vanish());
                document.body.className = '';
                meownessRays.deactivate();
                box.explode();
            }, 1000);
            break;
    }
});
